<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white">
            <br /><br /><br />
          
            <CCol sm="12" style="width: 80%; background-size: cover; margin: auto; color: #fff" class="d-sm-down-none">
                <br /><br /><br />
                <CRow>
                    <CCol sm="8">
    
                        <CCard class="bg-white border-grey-card b-20">
                            <CRow class="p-20 m-3">
    
                                <CCol sm="2">
                                    <span>
                                                                              <img v-if="filePath == ''" width="80px" src="../assets/img/DefaultUser.png" />
                                                                              <img v-else width="80px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff; object-fit: cover;"/>
                                                                            </span>
                                </CCol>
                                <CCol sm="8">
                                    <h1 class="custom-28px-700 text-black text-left mt-3">
                                        <strong>{{ user.name }}</strong>
                                    </h1>
                                    <p class="custom-16px-400 p-0">Students</p>
                                </CCol>
                                <CCol sm="2" class="text-right">
                                    <img src="../assets/img/edit.png" style="max-width:40px" @click="OpenEdit()" class="mt-3 text-right" />
                                </CCol>
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">About Me</label>
                                    <p class="font-color-171717" v-html="user.aboutUsCandidate"></p>
                                </CCol>
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">Your current field of expertise</label>
                                    <br /><br /><span class="custom-grey-radius text-black">-</span>
                                </CCol>
                                <CCol sm="12" class="mt-3">
                                    <label class="label-custom-header-subtitle mt-3">Desired career field</label>
                                    <br /><br /><span class="custom-grey-radius text-black">-</span>
                                </CCol>
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="card-grey p-40 b-20" style="border: none">
                            <h3 class="custom-20px-700 mt-2">My Account</h3>
                            <span class="text-black"><img src="../assets/img/location1.png" style="width: 30px" /> Kuala Lumpur</span>
                            <br />
                            <span class="text-black"><img src="../assets/img/earth.png" style="width: 30px" /> English, Melayu {{ user.country }}</span>
                            <h3 class="custom-20px-700 mt-4">Connect</h3>
                            <span class="text-black"><img src="../assets/img/Message.png" style="width: 30px" /> {{ user.email }}</span>
                            <br />
                            <!-- <span class="text-black"><img src="../assets/img/linkedin.png" style="width: 30px" /></span>
                                                <br />
                                                <span class="text-black"><img src="../assets/img/twitter.png" style="width: 30px" class="mr-1" /></span>
                                                <br /><br /> -->
    
                        </CCard>
                    </CCol>
                    <CCol sm="12" v-if="user.email != 'defaultuser@gmail.com'">
    
                        <CAlert show color="success">Video playback supported on all devices except ios & ipad os</CAlert>
                        <h3 class="custom-24px-600 font-color-171717">History</h3>
    
    
                        <CCard class="font-color-171717 b-20">
                            <CRow v-for="(item, index) in history" :key="item.sessionId" class="m-2 mt-3">
                                <CCol sm="2">
                                    <label class="mt-2"> <strong style="display: flex;">{{index+1 }}. <label class="ml-1">{{ item.sessionName }}</label></strong>
                                    </label>
    
                                </CCol>
                                <CCol sm="2" class="p-0">
                                    <label class="mt-2 custom-12px-500"> <img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalViews }} xViewed</label>
                                </CCol>
                                <CCol sm="2" class="p-0">
                                    <label class="mt-2 custom-12px-500"><img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalFeedback }} Feedbacks</label>
                                </CCol>
                                <CCol sm="1" class="p-0">
                                    <label class="mt-2 custom-12px-500"> <img style="max-width: 20px" src="../assets/img/offered.png" /> Offered</label>
                                </CCol>
                                <CCol sm="2" class="p-0">
                                    <label class="mt-2"> {{ item.sessionTime | moment("DD MMM YYYY") }} </label>
                                </CCol>
                                <CCol sm="3">
                                    <label class="custom-border-purple text-white mt-2" @click="OpenDetail(item)"><label class="pl-2 pr-2 m-2">Detail</label></label>
                                    <img src="../assets/img/detail.png" @click="openVideoPopup(item.sessionId)" style="max-width:30px" class="ml-2">
                                    <img src="../assets/img/delete.png" @click="OpenDelete(item)" style="max-width:30px" class="ml-2">
                                    <label class="custom-12px-500">Allow Company View</label>
                                    <CSwitch color="primary custom-border-purple" class="mx-1 custom-border-purple mt-1" name="switch1" :checked="item.companyView" @update:checked="UpdateCompanyViewSession(item.sessionId, $event)" shape="pill" />
                                </CCol>
    
    
    
    
                                <CCol sm="6">
                                    <div v-if="selectedRow === item.sessionId && showVideo" class="m-2">
                                        <CCard class="bg-grey m-2 p-20">
                                            <CRow v-for="items in item.SessionDetails" v-bind:key="items.indexNo" class="m-2">
    
                                                <CCol sm="4">
                                                    <label class="mt-4"> Question {{ items.indexNo }}</label>
                                                </CCol>
                                                <CCol sm="4">
                                                    <label class="mt-4"> <img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalViews }} xViewed</label>
                                                </CCol>
                                                <!-- <CCol sm="2">
                                                                                <label class="mt-4"><img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalFeedback }} Feedbacks</label>
                                                                            </CCol>
                                                                            <CCol sm="2">
                                                                                <label class="mt-4"> <img style="max-width: 20px" src="../assets/img/offered.png" /> Offered</label>
                                                                            </CCol> -->
                                                <CCol sm="4">
                                                    <label class="custom-border-purple p-2 mr-5 text-white mt-4" @click="openVideoPerQuestion(items.indexNo, item.sessionId)">Watch</label>
                                                </CCol>
                                            </CRow>
                                        </CCard>
                                    </div>
                                </CCol>
    
                            </CRow>
    
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>



    
            <CCol sm="12" style="width: 100%; background-size: cover; margin: auto; color: #fff" class="d-md-none">
                <br /><br /><br />
                <CRow>
                    <CCol sm="8">
                        <CCard class="bg-white border-grey-card b-20">
                            <CRow class="p-20 m-3">
                                <CCol sm="12">
                                    <img src="../assets/img/edit.png" style="max-width:30px" @click="OpenEdit()" />
                                </CCol>
                                <CCol sm="2">
                                    <span>
                                                                              <img v-if="filePath == ''" width="80px" height="80px" src="../assets/img/DefaultUser.png" />
                                                                              <img v-else width="80px" height="80px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff" />
                                                                            </span>
                                </CCol>
                                <CCol sm="8">
                                    <h1 class="custom-28px-700 text-black text-left mt-3">
                                        <strong>{{ user.name }}</strong>
                                    </h1>
                                    <p class="custom-16px-400 p-0">Students</p>
                                </CCol>
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">About Me</label>
                                    <p class="font-color-171717">{{ user.aboutUsCandidate }}</p>
                                </CCol>
                                <CCol sm="12">
                                    <label class="label-custom-header-subtitle mt-3">Your current field of expertise</label>
                                    <br /><br /><span class="custom-grey-radius text-black">-</span>
                                </CCol>
                                <CCol sm="12" class="mt-3">
                                    <label class="label-custom-header-subtitle mt-3">Desired career field</label>
                                    <br /><br /><span class="custom-grey-radius text-black">-</span>
                                </CCol>
                            </CRow>
                            <br /><br />
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="card-grey p-40 b-20" style="border: none">
                            <h3 class="custom-20px-700 mt-2">My Account</h3>
                            <span class="text-black"><img src="../assets/img/location1.png" style="width: 30px" /> Kuala Lumpur</span>
                            <br />
                            <span class="text-black"><img src="../assets/img/earth.png" style="width: 30px" /> English, Melayu {{ user.country }}</span>
                            <h3 class="custom-20px-700 mt-4">Connect</h3>
                            <span class="text-black"><img src="../assets/img/Message.png" style="width: 30px" /> {{ user.email }}</span>
                            <br />
    
    
                        </CCard>
                    </CCol>
                    <div v-if="user.email != 'defaultuser@gmail.com'">
                    <CCol sm="12">
                        <h3 class="custom-24px-600 font-color-171717">History</h3>
    
    
                        <CCard class="font-color-171717 b-20">
                            <CRow v-for="(item, index) in history" :key="item.sessionId" class="m-2 mt-3">
                                <CCol sm="2">
                                    <label class="mt-2"> <strong style="display: flex;">{{index+1 }}. <label class="ml-1">{{ item.sessionName }}</label></strong>
                                    </label>
    
                                </CCol>
                                <CCol sm="2">
                                    <label class="mt-2"> <img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalViews }} xViewed</label>
                                </CCol>
                                <CCol sm="2">
                                    <label class="mt-2"><img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalFeedback }} Feedbacks</label>
                                </CCol>
                                <CCol sm="2">
                                    <label class="mt-2"> <img style="max-width: 20px" src="../assets/img/offered.png" /> Offered</label>
                                </CCol>
                                <CCol sm="2">
                                    <label class="mt-2"> {{ item.sessionTime | moment("DD MMM YYYY") }} </label>
                                </CCol>
                                <CCol sm="2">
                                    <label class="custom-border-purple text-white mt-2" @click="OpenDetail(item)"><label class="pl-2 pr-2 m-2">Detail</label></label>
                                    <img src="../assets/img/detail.png" @click="openVideoPopup(item)" style="max-width:30px" class="ml-2">
                                    <img src="../assets/img/delete.png" @click="OpenDelete(item)" style="max-width:30px" class="ml-2">
                                </CCol>
    
    
    
    
                                <CCol sm="6">
                                    <div v-if="selectedRow === item.sessionId && showVideo" class="m-2">
                                        <CCard class="bg-grey m-2 p-20">
                                            <CRow v-for="items in item.SessionDetails" v-bind:key="items.indexNo" class="m-2">
    
                                                <CCol sm="4">
                                                    <label class="mt-4"> Question {{ items.indexNo }}</label>
                                                </CCol>
                                                <CCol sm="4">
                                                    <label class="mt-4"> <img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalViews }} xViewed</label>
                                                </CCol>
                                                <!-- <CCol sm="2">
                                                                                <label class="mt-4"><img style="max-width: 20px" src="../assets/img/Show.png" />{{ item.totalFeedback }} Feedbacks</label>
                                                                            </CCol>
                                                                            <CCol sm="2">
                                                                                <label class="mt-4"> <img style="max-width: 20px" src="../assets/img/offered.png" /> Offered</label>
                                                                            </CCol> -->
                                                <CCol sm="4">
                                                    <label class="custom-border-purple p-2 mr-5 text-white mt-4" @click="openVideoPerQuestion(items.indexNo, item.sessionId)">Watch</label>
                                                </CCol>
                                            </CRow>
                                        </CCard>
                                    </div>
                                </CCol>
    
                            </CRow>
    
                        </CCard>
                    </CCol>
                    </div>
                </CRow>
            </CCol>
    
    
    
    
    
            <div v-if="isPopupVisible3" class="popup-all backdrop-all">
                <div class="popup-all2">
    
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Details</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closeVideoPopup" /></CCol>
                    </CRow>
                    <div class="custom-scroll">
                        <CCard class="p-20 font-color-171717 m-2">
                            <CRow class="m-2 p-20">
                                <CCol sm="12">
                                    <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width: 100%;height:450px"></iframe>
    
                                    <CRow>
                                        <CCol sm="6"> <label class="ml-2 mr-2 mt-2">Current Video Question :{{ questionVideo.IndexNo }}</label></CCol>
                                        <CCol sm="6"> <span class="custom-border-purple p-2 text-center text-white" @click="nextQuestion(questionVideo.IndexNo, questionVideo.SessionId)">
                                         <label class="ml-2 mr-2 mt-2">Next Video</label></span>
    
                                            <label class="custom-border-purple-white ml-3 mr-2 mt-2 font-color-928AFD text-center p-1" @click="InsertShare(questionVideo.SessionId)"><img style="width:20px" src="../assets/img/share.png" /><span class="mr-2 ml-2">{{ shareLabel }}</span></label></CCol>
    
                                    </CRow>
    
                                    <h4 class="mt-2">Question:</h4>
                                    <p>{{ questionVideo.Question }}</p>
                                    <h4 class="mt-3">Answer:</h4>
                                    <p>{{ questionVideo.Answer }}</p>
                                </CCol>
                                <CCol sm="5" class="p-0">
    
                                    <h3 class="custom-18px-500 font-inter mt-2">
                                        4 personal character indicators
                                    </h3>
                                    <CCard style="max-height:200px">
                                        <br />
                                        <CRow>
                                            <CCol v-if="report === 'Not available yet.'" sm="6">
                                                <CRow class="text-center m-0">
                                                    <CChartDoughnut :datasets="defaultDatasets" />
                                                    <br />
                                                    <span class="text-center ml-2">No data available.</span>
                                                </CRow>
    
                                            </CCol>
    
                                            <CCol v-else sm="6" v-for="(dataset, index) in datasets" :key="index">
                                                <div class="text-center">
                                                    <CChartDoughnut :datasets="[dataset]" :labels="[dataset.label]" />
                                                </div>
                                            </CCol>
    
    
    
                                        </CRow>
                                        <br />
                                    </CCard>
    
                                    <CCard>
                                        <h3 class="custom-14px-400 font-inter m-2">Overall performance</h3>
    
                                        <CChartRadar :datasets="radarChartData.datasetsRadar" :options="defaultOptionsRadar" :labels="radarChartData.labels" />
                                    <br />
                                        </CCard>
    
    
    
    
                                </CCol>
                                <CCol sm="7" class="p-0">
    
                                    <CCol sm="12">
    
    
                                        <h3 class="custom-18px-500 font-inter mt-2">Detail Explanation & Score</h3>
                                        <h3 class="custom-14px-400 font-inter">Ranked based on users answer</h3>
                                        <CCard>
    
                                            <CRow class="m-2">
                                                <CCol v-if="report === 'Not available yet.'" sm="6">
                                                    <p>No data available.</p>
                                                </CCol>
                                                <CCol v-else sm="6" v-for="(trait, index) in report" :key="index">
                                                    <div>
                                                        <CRow class="mt-2">
                                                            <CCol sm="8">
                                                                <h4 class="custom-18px-600 font-color-171717 font-inter font-small">{{ trait.Type }}</h4>
                                                            </CCol>
                                                            <CCol sm="4">
                                                                <h4 class="custom-16px-500 font-color-171717 font-inter">{{ trait.Value }} /10</h4>
                                                            </CCol>
    
                                                            <CCol sm="12">
                                                                <p class="custom-14px-400 mt-2 font-color-171717">{{ trait.Details }}</p>
                                                            </CCol>
                                                            <CCol sm="12">
                                                                <!-- <progress :value="trait.Value" max="10" show-percentage style="width:100%"></progress> -->
                                                                <CProgress :value="trait.Value" show-percentage color="success" max="10" :animated="animate" class="mb-2" />
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </CCol>
    
                                            </CRow>
    
                                        </CCard>
    
    
                                    </CCol>
                                </CCol>
                                <CCol sm="12">
                                    <h3 class="custom-16px-600">Summary</h3>
                                    <h4 class="custom-18px-400 font-inter font-small" v-if="reportSummary != null">
                                        <pre>{{ reportSummary }}</pre>
                                    </h4>
                                </CCol>
                                <CCol sm="6"> <label class="custom-border-purple-white p-2 mr-2 font-color-928AFD text-center mt-5 mb-5" style="width:100%"><img style="width:20px" src="../assets/img/Download.png" />Download</label></CCol>
                                <CCol sm="6"> <label class="custom-border-purple p-2 mr-2 text-white text-center mt-5 mb-5" style="width:100%">Continue</label></CCol>
    
                            </CRow>
                        </CCard>
                    </div>
                </div>
            </div>
    
            <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/Ellipsedelete.png" />
                        <h3 class="custom-18px text-center mt-3">
                            Are you sure want to delete <br /> {{ sessionInterview }} ?
                        </h3>
                        <div class="mt-4">
                            <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="DeleteSession(sessionDelete)" style="width:100px">Yes</label>
                            <label class="custom-border-purple p-2 text-center mr-2" @click="CloseDelete()" style="width:100px">Cancel</label>
                        </div>
                    </div>
    
                </div>
            </div>
    
            <div v-if="isSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/d2.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Deleted Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
    
            <div v-if="isVideoPerQuestion" class="popup-all backdrop-all">
                <div class="popup-all2">
                    <div class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closeVideoPerQuestion" />
                    </div>
                    <div class="custom-scroll">
                        <div>
                            <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width:100%;height:400px;"></iframe>
                            <h3 class="custom-30px-600 text-left mt-3 font-inter font-color-171717">Interview Question {{ questionVideo.IndexNo }} </h3>
                            <h4 class="custom-20px-500 text-left font-inter font-color-171717" style="display: flex;"><strong>{{ questionVideo.Question }}. <label class="ml-2">{{ question }}</label></strong></h4>
                            <h4 class="custom-20px-700 text-left font-inter mt-4"><strong>Answers</strong></h4>
                            <p class="custom-18px-500 font-color-171717">{{ questionVideo.Answer }}</p>
                        </div>
                        <div class="text-center">
                            <span class="custom-border-purple p-2 text-center text-white" @click="nextQuestion(questionVideo.IndexNo, questionVideo.SessionId)">
                                             <label class="ml-2 mr-2">Next</label></span>
                            <br />
                        </div>
    
    
                    </div>
                </div>
    
    
            </div>
    
    
            <div v-if="isSuccessCompanyView" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Save Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccessCompanyView" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
        </CCol>
        <Footerlayout class="footer-layout"></Footerlayout>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
import { CChartRadar } from '@coreui/vue-chartjs'



export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        CCol,
        CChartDoughnut,
        CChartRadar
    },
    created() {



    },
    computed: {
        defaultDatasets() {
            return [{
                backgroundColor: [

                    '#928AFD'
                ],
                data: [100]
            }]
        },

        defaultDatasets1() {
            return [{
                    label: '2019',
                    backgroundColor: 'rgba(179,181,198,0.2)',
                    borderColor: 'rgba(179,181,198,1)',
                    pointBackgroundColor: 'rgba(179,181,198,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(179,181,198,1)',
                    tooltipLabelColor: 'rgba(179,181,198,1)',
                    data: [65, 59, 90, 81, 56, 55, 40]
                },
                {
                    label: '2020',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    borderColor: 'rgba(255,99,132,1)',
                    pointBackgroundColor: 'rgba(255,99,132,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(255,99,132,1)',
                    tooltipLabelColor: 'rgba(255,99,132,1)',
                    data: [28, 48, 40, 19, 96, 27, 100]
                }
            ]
        },
        defaultOptions() {
            return {
                aspectRatio: 1.5
            }
        }
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isActive: false,
            user: {},
            history: [],

            showToggle: false,
            showVideo: false,
            selectedRow: null,
            isPopupVisible3: false,

            videoUrl: '',
            questionNo: '',
            question: '',
            filePath: "",
            sessionDelete: "",
            sessionInterview: "",
            sessionQuestion: "",
            isPopupDelete: false,
            isSuccess: false,
            isVideoPerQuestion: false,
            questionVideo: {},

            showVideo: true,
            showNextVideo: false,
            report: [],
            reportRadar: [],
            reportRank: [],
            reportSummary: '',
            datasets: [],
            maxScore: 10, // Maximum score possible
            max: 10,
            options: {
                plugins: {
                    legend: {
                        display: false // Hides the legend
                    },
                    tooltip: {
                        enabled: true, // Enables tooltip
                        callbacks: {
                            label: function(context) {
                                // Display only value inside the tooltip
                                const value = context.raw || 0;
                                return `${value}`;
                            }
                        }
                    },
                    datalabels: {
                        display: function(context) {
                            // Show datalabels only for the value part
                            return context.dataIndex === 0;
                        },
                        formatter: function(value) {
                            return value; // Display the value
                        },
                        color: '#000', // Set text color
                        font: {
                            size: 14, // Set font size
                            weight: 'bold' // Set font weight
                        }
                    }
                }
            },
            shareLabel: "Copy & Share",
            isSuccessCompanyView: false,
            radarChartData: {
                labels: [],
                datasetsRadar: [{
                    label: 'AI Video Score',
                    backgroundColor: 'rgba(145, 138, 246, 0.25)',
                    borderColor: 'rgba(113, 100, 169, 1)',
                    data: []
                }],
            },
            defaultOptionsRadar: {
        aspectRatio: 1.5,
        scales: {
          r: {
            angleLines: { display: true },
            ticks: {
              suggestedMin: 1, // Adjusted minimum value
              suggestedMax: 10,
              beginAtZero: false,
              stepSize: 2
            }
          }
        }
    }


        };
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetHistoryUser();

              
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        OpenDetail(item) {
            this.showVideo = !this.showVideo;
            this.selectedRow = item.sessionId;

        },
        OpenDelete(item) {
            this.sessionDelete = item.sessionId;
            this.sessionInterview = item.sessionName;
            this.isPopupDelete = true;
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetHistoryUser() {
            try {
                const response = await this.$API.get(this.$GetUserHistory, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.history = response.data.map(item => ({
                        ...item,
                        detailsVisible: false,
                    })).filter(item => {
                        // Apply additional filter conditions here
                        return item.SessionDetails &&
                            item.SessionDetails.length > 0 &&
                            item.SessionDetails.some(detail => detail.indexNo === 1 && detail.url !== "No recorded video.");
                    });;
                    console.log("historyInfo", this.history);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user history:", response);
                }
            } catch (error) {
                console.error("Error fetching user history:", error);
                // Handle the error here
            }
        },
        async getListVideo() {
            try {
                const response = await this.$API.get(this.$ListVideo);
                if (response.status === 200) {
                    this.list = response.data;
                    this.photoURL = this.list.profilePhoto;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReport(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.report = response.data;
                    //this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportRadar(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRadar = response.data;
                    this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        processReportData() {
      // Extract Type and Value for labels and data
      this.radarChartData.labels = [...this.reportRadar.map(item => item.Type)];
      this.radarChartData.datasetsRadar[0].data = [...this.reportRadar.map(item => item.Value)];
    },
        async getReportRank(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    const relevantTypes = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
                    this.reportRank = response.data.filter(item => relevantTypes.includes(item.Type));
                    console.log("rank" + this.reportRank);
                    this.prepareChartData(this.reportRank);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportSummaryRank(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportSummary = this.reformatSummary(response.data.Summary);
                } else {
                    // Handle non-200 status code
                    this.reportSummary = null;
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        reformatSummary(summaryText) {
            return summaryText ? summaryText.replace(/:/g, ':\n') : null;
        },
        prepareChartData() {
            const relevantCategories = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
            const maxScore = 10;

            this.datasets = this.reportRank
                .filter(item => relevantCategories.includes(item.Type))
                .map(trait => ({
                    data: [trait.Value * 10, (maxScore - trait.Value) * 10],
                    backgroundColor: ['#928AFD', '#E0E0E0'],
                    label: trait.Type
                }));
        },

        openVideoPopup(sessionId) {
            //console.log("video" + url);
            // this.videoUrl = url;
            this.getReport(sessionId);
            this.getReportRadar(sessionId);
            this.getReportRank(sessionId);
            this.getReportSummaryRank(sessionId);
            this.getListQuestion(1, sessionId);
            this.isPopupVisible3 = true;
        },
        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
        },
        openVideoPerQuestion(index, sessionId) {
            console.log("testing" + index + sessionId);
            this.getListQuestion(index, sessionId);

            this.isVideoPerQuestion = true;
        },
        closeVideoPerQuestion() {
            this.isVideoPerQuestion = false;
        },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.$router.push("/Login");
                    }
                });
        },
        DeleteSession: function(sessionId) {
            const formData = new FormData();

            formData.append("sessionId", sessionId);

            return this.$API
                .post(this.$DeleteSession, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupDelete = false;
                        this.GetHistoryUser();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isSuccess = false;
        },
        CloseDelete() {
            this.isPopupDelete = false;
        },

        async nextQuestion(index, sessionId) {
            this.index++;
            this.index1 = index + 1;
            this.showVideo = false;
            console.log("index" + this.index1);
            this.getListQuestion(this.index1, sessionId);

        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(
                    `${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {}
            } catch (error) {}

        },
        OpenEdit() {
            this.$router.push("Editprofile");
        },
        async InsertShare(sessionId) {
            try {

                const response = await this.$API.get(this.$GetSessionUrl + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.share = response.data;
                    await this.copyToClipboard(this.share);

                    this.copied = true;
                    this.shareLabel = "Copied";
                    setTimeout(() => {
                        this.copied = false;
                    }, 2000); // Hide the notification after 2 seconds
                } else {
                    // Handle non-200 status code
                    this.share = null;
                }
            } catch (error) {
                // Handle the error here
                this.share = null;
            }

        },
        async copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch (error) {
                console.error('Failed to copy: ', error);
            }
        },
        toggleAllowCompanyView(item, checked) {
            item.companyView = checked;
            // Optionally, send an update request to the server here
        },
        UpdateCompanyViewSession: function(sessionId, checked) {
            const formData = new FormData();

            formData.append("sessionId", sessionId);
            formData.append("CompanyView", checked ? "true" : "false");

            return this.$API
                .post(this.$UpdateCompanyView, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isSuccessCompanyView = true;
                        this.GetHistoryUser();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessCompanyView() {
            this.isSuccessCompanyView = false;
        },

    }
};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}

.progress-bar {
    background: #34B53A;
}

progress.progress-success::-webkit-progress-value {
    background-color: #28a745;
    /* Bootstrap success color */
}

progress.progress-success::-moz-progress-bar {
    background-color: #28a745;
    /* Bootstrap success color */
}

progress.progress-success {
    background-color: #d4edda;
    /* Light success background */
}
</style>
  